import React from 'react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { formatInrReportAmount } from './formatInrReportMoney';

export interface ChartPoint {
  label: string;   // "Apr '25"
  total: number;   // INR amount
  count: number;   // number of paid invoices
}

interface Props {
  data: ChartPoint[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomTooltip: React.FC<any> = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const { total, count } = payload[0].payload as ChartPoint;
  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-md px-3 py-2 text-xs">
      <p className="font-semibold text-slate-700 mb-1">{label}</p>
      <p className="text-blue-600 font-bold">{formatInrReportAmount(total)}</p>
      <p className="text-slate-400">{count} invoice{count !== 1 ? 's' : ''}</p>
    </div>
  );
};

export const ExpenseChart: React.FC<Props> = ({ data }) => {
  const hasData = data.some(d => d.total > 0);

  if (!hasData) {
    return (
      <div className="h-[260px] flex items-center justify-center text-slate-400 text-sm">
        No paid invoices this period
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={260}>
      <AreaChart data={data} margin={{ top: 8, right: 12, left: 8, bottom: 4 }}>
        <defs>
          <linearGradient id="gradExpense" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%"  stopColor="#2563EB" stopOpacity={0.18} />
            <stop offset="95%" stopColor="#2563EB" stopOpacity={0.02} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" />
        <XAxis
          dataKey="label"
          tick={{ fontSize: 10, fill: '#94A3B8' }}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          tickFormatter={(v: number) => formatInrReportAmount(v)}
          tick={{ fontSize: 10, fill: '#94A3B8' }}
          axisLine={false}
          tickLine={false}
          width={72}
        />
        <Tooltip content={<CustomTooltip />} />
        <Area
          type="monotone"
          dataKey="total"
          stroke="#2563EB"
          strokeWidth={2.5}
          fill="url(#gradExpense)"
          dot={{ r: 3, fill: '#2563EB', strokeWidth: 0 }}
          activeDot={{ r: 5, fill: '#2563EB', strokeWidth: 0 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
